require("../../scss/az-ships.scss");

import Application from "./application";

import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from '../jsx/shortlist/shortlist-button';
import SearchTemplateBasic from "../jsx/search/template-basic";
import CarouselBehaviour from "../behaviours/carousel-behaviour"
import TruncateBehaviour from "../behaviours/truncate-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import CruiseShipSearch from "../jsx/cruise-ship-search";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";

let config = {};
config.behaviours = {
    "MobileMenuBehaviour": new MobileMenuBehavior(),
    "EqualizeBehaviour": new EqualizeBehavior(),
    'CarouselBehaviour': new CarouselBehaviour(),
    'TruncateBehaviour': new TruncateBehaviour(),
    'ToggleClassBehaviour': new ToggleClassBehavior(),
    'HideShowBehaviour': new HideShowBehaviour()
};

config.components = {
    "shortlist-count": ShortlistCount,
    "search-form": SearchTemplateBasic,
    "shortlist-button": ShortlistButton,
    'cruise-ship-search': CruiseShipSearch
}
new Application(config);

window.loadShipsJs = function(){
    window.glide = {};
    [...document.querySelectorAll('.az-list--nav-item')].map(navItem => {
        navItem.addEventListener('click', e => {
            [...document.querySelectorAll('.az-list--category')].map(cat => cat.classList.remove('az-list--category-show'));
            [...document.querySelectorAll('.az-list--nav-item')].map(cat => cat.classList.remove('az-list--nav-item-active'));

            const target = e.target.getAttribute('data-target');

            if(target){
                e.target.classList.add('az-list--nav-item-active');
                document.querySelector(target).classList.add('az-list--category-show');
            } else {
                [...document.querySelectorAll('.az-list--category')].map(cat => cat.classList.add('az-list--category-show'));
            }

        })
    });
};

document.readyState !== "loading" ? window.loadShipsJs() : document.addEventListener("DOMContentLoaded",  window.loadShipsJs);